import { optedOut } from "./pageViews";

/**
 * Reports a step someone reached in a tool to Solstack's own step log
 * (worker/analytics.js → POST /api/ev, read back on the Tools view of
 * /admin/analytics): a wallet scanned, the review card shown, Confirm
 * pressed, the run confirmed or failed, a result image shared. That's what
 * shows where people stop between opening a tool and finishing with it;
 * page views alone can't.
 *
 * `kind` is one of TOOL_EVENT_KINDS in worker/analytics.js. `address` is the
 * connected wallet, if any — never pass an address someone pasted.
 * `detail` holds a few counts and short strings (the error they saw, say).
 * The page path names the tool. ?notrack=1 (see pageViews.js) stops these too.
 */
export function logToolEvent(kind, { address = "", network = "", detail = null } = {}) {
  try {
    if (typeof window === "undefined" || navigator.webdriver || optedOut()) return;
    const body = JSON.stringify({
      k: kind,
      t: window.location.pathname,
      a: address || undefined,
      n: network ? String(network).toLowerCase() : undefined,
      d: detail || undefined,
    });
    if (navigator.sendBeacon?.("/api/ev", new Blob([body], { type: "text/plain" }))) return;
    fetch("/api/ev", { method: "POST", body, keepalive: true }).catch(() => {});
  } catch {
    // Reporting must never break the tool.
  }
}
